import React from 'react';

const AlertBadge = ({ type, text }) => {
    const base = 'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase';

    const variants = {
        fault: 'bg-error text-error-foreground',
        alarm: 'bg-warning text-warning-foreground',
        info: 'bg-info text-info-foreground',
        ok: 'bg-success text-success-foreground',
        warning: 'bg-warning text-warning-foreground',
        error: 'bg-error text-error-foreground',
    };

    const labels = {
        fault: 'Fault',
        alarm: 'Alarm',
        info: 'Info',
        ok: 'OK',
        warning: 'Warning',
        error: 'Error',
    };

    const classes = variants[type] ?? 'bg-muted text-muted-foreground';
    const label = text || labels[type] || 'Unknown';

    return <span className={`${base} ${classes}`}>{label}</span>;
};

export default AlertBadge;
